<mat-checkbox
    #inputRef
    class="adc-checkbox {{ shape() }}"
    data-unit="adc-checkbox"
    [value]="value()"
    [checked]="checked()"
    [disabled]="isDisabled()"
    [name]="name() ?? null"
    [tabIndex]="tabIndex() ?? null"
    [attr.aria-label]="ariaLabel() || null"
    (change)="onChange($event)"
    (focusin)="onFocus()"
    (focusout)="onBlur()"
    [disableRipple]="true"
    [indeterminate]="indeterminate()"
    [labelPosition]="labelPosition()"
>
    <ng-content />
    @if (label() || subtext()) {
        <div class="adc-checkbox__label" data-unit="adc-checkbox-label">
            <div class="adc-checkbox__description" data-unit="adc-checkbox-description">
                @if (label()) {
                    <div #labelTextRef class="adc-checkbox__label-text" data-unit="adc-checkbox-label-text">
                        {{ label() }}
                    </div>
                }
                @if (subtext()) {
                    <div #subtextRef class="adc-checkbox__subtext" data-unit="adc-checkbox-subtext">
                        {{ subtext() }}
                    </div>
                }
            </div>
        </div>
    }
</mat-checkbox>
